import React from 'react';
import { pillars } from '../../data/content';
export function KeyBenefit() {
  return <section aria-labelledby="beneficio-title" className="w-full bg-ink-950" data-id="element-89" data-mp="2s5hm2lvxnrlk">
      <div className="mx-auto max-w-6xl px-5 py-16 text-center md:py-24" data-id="element-90" data-mp="2s7kfzh07i4vk">
        <div className="mx-auto max-w-3xl" data-id="element-91" data-mp="2dioc7w56ne0r">
          <h2 id="beneficio-title" className="font-display text-3xl font-black leading-tight text-white md:text-[2.75rem]" data-id="element-92" data-mp="2ifesokkwgbmp">
            No es solamente una videollamada
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-body md:text-lg" data-id="element-93" data-mp="3b3ke79js24nl">
            Además de recibir asesoramiento personalizado sobre la situación actual de tu hijo, te
            llevás herramientas para seguir acompañando su carrera y tomar mejores decisiones en el
            futuro.
          </p>
        </div>

        <ul className="mt-12 grid border-t border-ink-border md:grid-cols-3 md:divide-x md:divide-ink-border" data-id="element-94" data-mp="1kqmmmms7m5d4">
          {pillars.map(pillar => <li key={pillar.word} className="border-b border-ink-border px-4 py-8 md:border-b-0 md:py-10" data-id="element-95" data-mp="2nzrmq75pfve1">
              <p className="font-display text-3xl font-black uppercase tracking-wide text-brand-gold md:text-4xl" data-id="element-96" data-mp="2j1q7xyfbai8d">
                {pillar.word}
              </p>
              <p className="mx-auto mt-3 max-w-xs text-[16px] leading-relaxed text-body" data-id="element-97" data-mp="2wylg7onqo5nd">
                {pillar.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}